import {
  message,
  Space,
  Select,
} from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  MensajeError,
  ModalItem,
  ButtonItem,
  Form,
  FormItem,
  InputItem,
  SelectItem
} from "../../../../Components/Items";

const {Option} = Select

class CancelarFacturaGlobal extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    pdf: null,
  };
  onFinishFailed(e) {
    message.error("Revisa que los datos sean correctos");
  }
  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "ventas/cancelarFacturaGlobal",
        { ...values, facturaGlobalId: this.props.id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
          if (res.data.success === 2) {
              message.success("Factura global cancelada");
            } else if (res.data.success === 1) {
                MensajeError({
                  message: res.data.errorTimbrado?.titulo || "No se pudo cancelar la factura global",
                  description: res.data.errorTimbrado?.mensaje || res.data.message,
                  detalleTecnico: res.data.errorTimbrado?.detalleTecnico,
                });
            } else {
                message.error("Sucedio un eror y no se pudo cancelar");
            }
            this.formRef.current.resetFields();
        this.setState({ loading: false });
        this.cerrarCancelarFacturaGlobal();
      });
  }
  cerrarCancelarFacturaGlobal() {
    this.props.cerrarCancelarFacturaGlobal();
  }
  render() {
    return (
      <ModalItem
        title="Cancelar Factura Global"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarCancelarFacturaGlobal.bind(this)}
        paddingTop
      >
        <Form
          ref={this.formRef}
          name="cancelarFacturaGlobal"
          layout
          width={700}
          onCancel={this.cerrarCancelarFacturaGlobal.bind(this)}
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          <FormItem label="Motivo" name="motivo" required pattern margin max={200}>
          <SelectItem placeholder="Motivo">
                <Option value='01'>01 - Comprobante emitido con errores con relación.</Option>
                <Option value='02'>02 - Comprobante emitido con errores sin relación.</Option>
                <Option value='03'>03 - No se llevó a cabo la operación.</Option>
                <Option value='04'>04 - Operación nominativa relacionada en una factura global.</Option>
            </SelectItem>
          </FormItem>
          <FormItem label="Folio Sustitucion" name="folioSustitucion" pattern margin max={200}>
            <InputItem placeholder="Folio de Sustitucion" />
          </FormItem>
          <div
            style={{
              display: "flex",
              justifyContent: "right",
              marginTop: 20,
              marginBottom: 10,
            }}
          >
            <Space>
              <ButtonItem
                type="primary"
                htmlType="submit"
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Cancelar Factura Global
              </ButtonItem>
              <ButtonItem
                type="primary"
                danger
                onClick={this.cerrarCancelarFacturaGlobal.bind(this)}
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Regresar
              </ButtonItem>
            </Space>
          </div>
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(CancelarFacturaGlobal);
